// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"d975ef90","921":"6545fdaf"}[chunkId] + ".chunk.css";
};